import axios from "axios";
import { getLocalStorage } from "../utils/Utils";
import { STORAGE_KEY, TOKEN_DATA_TYPE } from "./constant";

function interceptor() {
	axios.interceptors.request.use(
		(req) => {
			if (typeof window !== "undefined" && req?.headerToken === TOKEN_DATA_TYPE.ACCESS) {
				const getJWTToken = getLocalStorage(STORAGE_KEY.JWTToken);
				if (getJWTToken) {
					req.headers.Authorization = `Bearer ${getJWTToken}`;
				}
			}
			return req;
		},
		(error) => Promise.reject(error),
	);

	axios.interceptors.response.use(
		(res) => res,
		(error) =>
			// if (error.response?.status === 403) {
			//   if (error.response.data) {
			//     error.response.data.message = '';
			//   }
			//   handleLogout?.();
			// window.location.href = window.location.origin;
			// }
			Promise.reject(error),
	);
}

export default interceptor;
